import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { makeStyles } from '@material-ui/core/styles'

const styles = {
  flexContainer: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
  },
}
const useStyles = makeStyles(styles)

export default function DisabledDeck(props) {
  const { t } = useTranslation()

  const { message = t('deck:messages-isDisabled') } = props

  const classes = useStyles()

  return <div className={classes.flexContainer}>{message}</div>
}

DisabledDeck.propTypes = {
  message: PropTypes.string,
}
